import _ from 'lodash';
import React from 'react';
import classnames from 'classnames';
import { getCurrentUser } from 'src/models/lmsConfig/queries';
import { useAppSelector } from 'src/store/hooks';
import { getModuleProps, isLmsWeb } from 'src/workspace/utils';
import { getKeyMetricsDetails } from '../selector';
import KeyMetricsHeader from './components/header';
import KeyMetricsOverview from './components/overview';
import TeamBreakdown from './components/teamBreakdown';
import styles from './index.module.scss';

function KeyMetricsDetails() {
  const details = useAppSelector(getKeyMetricsDetails);
  const currentUser = getCurrentUser();
  const { subordinatesCount } =
    getModuleProps?.()?.getAllUsers?.()?.[currentUser?.code] || {};
  return (
    <div
      className={classnames(styles.details, {
        [styles.details__lmsWeb]: isLmsWeb() && !_.isEmpty(details),
      })}
    >
      <KeyMetricsHeader />
      {Boolean(subordinatesCount) && <TeamBreakdown />}
      <KeyMetricsOverview />
    </div>
  );
}

export default KeyMetricsDetails;
